import { render, staticRenderFns } from "./TransactionListCard.vue?vue&type=template&id=83b7a082&lang=pug"
import script from "./TransactionListCard.vue?vue&type=script&lang=js"
export * from "./TransactionListCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports